var Star = function() {
    return {
        clickHandler: function(cb) {
            return function(event) {
                event = event || window.event;
                if (event.stopPropagation) {
                    // mobile-only to prevent matchtap open when star is tapped
                    event.stopPropagation();
                }
                var clickedElem = this;
                var mid = $(clickedElem).data('mid');
                if (mid == undefined) {
                    return;
                }
                if (!window.PushNotifications) {
                    Generic.log_error('PushNotifications missing from ' + window.location.pathname);
                }
                if (window.PushNotifications &&
                    !Generic.jsCookies.hasItem('acceptedPushNotifications')) {
                    PushNotifications.askForPermission(function() {
                        cb(clickedElem, mid);  // toggle fav AFTER registration done
                    });
                    return;
                }

                cb(clickedElem, mid);
            };
        },
        saveStar: function(mid) {
            let push_subscription_hash = false;
            if (!window.PushNotifications) {
                Generic.log_error('PushNotifications missing from ' + window.location.pathname);
            } else if (PushNotifications.userAccepted()) {
                push_subscription_hash = window.localStorage.getItem('pushSubscriptionHash');
            }
            Ajax.toggleFav(mid, push_subscription_hash ? push_subscription_hash : '');
        },
        initMatchStarHandler: function() {
            if (!Generic.loggedin && Generic.jsCookies.hasItem('fav_matches')) {
                var favs = JSON.parse(Generic.jsCookies.getItem('fav_matches'));
                for (var ix in favs) {
                    if ($('.ii__fav_star').data('mid') == favs[ix]) {
                        $('.ii__fav_star').removeClass('fal').addClass('fas');
                    }
                }
            }
            $('.ii__fav_star').off('click').click(
                Star.clickHandler(function(elem, mid) {
                    Star.toggleMatchStarIcon(elem);
                    Star.saveStar(mid);
                }));
        },
        toggleMatchStarIcon: function(elem) {
            const remAddClass = ['fal', 'fas'];
            const star = $(elem);
            const remIndex = star.hasClass('fal') ? 1 : 0;
            star.removeClass(remAddClass[1 - remIndex]).addClass(remAddClass[remIndex]);
        },
    };
}();

if (typeof module !== 'undefined') {
    module.exports = Star;
}
